import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import ViewPurchaseOrderLayer from "../components/ViewPurchaseOrderLayer";

const ViewPurchaseOrderPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  

 const fetchOrder = async () => {
  try {
    const response = await fetch(`${API_URL}/api/purchase-orders/single/${id}`);
    const data = await response.json();

    // ✅ If backend returns [ {...} ] instead of { ... }
    const formatted = Array.isArray(data) ? data[0] : data;
    setOrder(formatted);
  } catch (error) {
    console.error("Error fetching purchase order:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchOrder();
  }, [id]);

  return (
    <MasterLayout>
      <Breadcrumb title="View Purchase Order" />
      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}
      {!loading && !order && (
        <div className="text-center mt-4">
          <p>Purchase Order not found.</p>
          <Link to="/purchase-orders" className="btn btn-secondary mt-2">
            Back to List
          </Link>
        </div>
      )}
      {!loading && order && <ViewPurchaseOrderLayer order={order} />}
    </MasterLayout>
  );
};

export default ViewPurchaseOrderPage;
